<template>
  <div>
    <!-- 查询 -->
    <div style="text-align:right">
      <monthQuickQuery :size="size" :isNow="false" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" :downloading="downloading" ></monthQuickQuery>
    </div>
    <!-- 表格 -->
    <div class="page_container">
      <el-table 
        :data="dataList" 
        border 
        :size="size"
        :span-method="objectSpanMethod"
        :cell-style="cellStyle"
        v-loading="loading"
      >
        <el-table-column :label="$t('runState.carNo')" align="center" prop="carNo"></el-table-column>
        <el-table-column :label="$t('runState.statMonth')" align="center" prop="statDate"></el-table-column>
        <el-table-column :label="$t('runState.driveDuration')" align="center" prop="driveDuration">
          <template slot-scope="scope">{{fixed2(scope.row.driveDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.idleDuration')" align="center" prop="idleDuration">
          <template slot-scope="scope">{{fixed2(scope.row.idleDuration)}}</template>
        </el-table-column>
        <el-table-column :label="$t('runState.rate')" align="center" prop="driveRatio">
          <template slot-scope="scope">{{fixed2(scope.row.driveRatio * 100)}} %</template>
        </el-table-column>
      </el-table>
    </div>
    <kl-pagination
      :total="total"
      :currentPage="currentPage"
      @current-change="currentchange"
      @size-change="sizeChange"
    ></kl-pagination>
  </div>
</template>
<script>
import monthQuickQuery from './components/monthQuickQuery.vue'
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
export default {
  props:{
    size:{
      type:String,
    },
    isClicked:{
      type: Boolean,
      default:false,
    }
  },
  components:{monthQuickQuery},
  data(){
    return{
      downloading:false,
      vehicles:"",
      pageSize:10,
      currentPage:1,
      total:0,
      form:undefined,
      loading:false,
      needMergeArr: ["carNo"], 
      rowMergeArrs: [],
      dataList:[],
      LanguageId:1,
    }
  },
  computed:{
    ...mapState({
        operator: (state) => state.user.operator,
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  watch:{
    // tabs点击才进行初次加载
    isClicked(newVal){
      if(newVal){
        this.getList();
      }
    }
  },
  methods:{
    fixed2(val){
      if(val == 0 || val == null || val == undefined || val == ""){
        return 0;
      }
      if(Number.isInteger(val)) return val;
      return val.toFixed(2)
    },
    sizeChange(val){
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    currentchange(page){
      this.currentPage = page;
      this.getList();
    },
    getList(){
      this.loading = true;
      this.$api.runStateInfo({
        vehicles: this.vehicles,
        queryType: 0,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",
        PageNo: this.currentPage,
        PageSize: this.pageSize,
        IsExport: 0, // 0是查询 1是下载
        Language: this.LanguageId,
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.total = res.count;
          this.loading = false;
        }
      })
      .catch((e)=>{
          this.loading = false;
          this.dataList = [];
          this.total = 0;
      })
    },
    cellStyle({row,columnIndex}){
      if(columnIndex == 0 || columnIndex == 1){
        return "background:rgb(238, 244, 255)"
      }
    },
    download(){
      
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api.downMonthUseInfo({
        vehicles: this.vehicles,
        queryType: 1,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",
        IsExport: 1, // 0是查询 1是下载
        Language: this.LanguageId,
      })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("runState.monthRate")+that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if(j == "driveDuration") {
          return this.fixed2(v[j]);
        }else if(j == "idleDuration") {
          return this.fixed2(v[j]);
        }else if(j == "driveRatio") {
          return this.fixed2(v[j] * 100) + " %";
        }else{
          return v[j]
        }
      }))
    },
    quickQuery(form){
      this.form = form;
      this.values = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
    },
    handleQuery(form){
      this.form = form;
      this.values = this.getSelectedVehicles();
      if(this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      if(this.isClicked){
        this.currentPage = 1;
        this.getList();
      }
    },
    
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 获取表格数据
      const data = this.dataList;
      // 合并 carNo 列
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.carNo === data[rowIndex - 1].carNo) {
          return { rowspan: 0, colspan: 0 };  // 合并当前和上一行的 carNo
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].carNo === row.carNo) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1 // carNo 列合并
          };
        }
      }

      // 其他列的处理
      return {
        rowspan: 1,
        colspan: 1
      };
    
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
  },
  mounted(){
    this.LanguageId = language(this.$store.getters.locale)
  }
}
</script>
<style scoped>

</style>